import React, { Component } from "react";
import { Link } from "react-router-dom";

class SubNav extends Component {
  render() {
    return (
      <div className="subnav">
        <ul align="center">
          <li className="subnav-item">
            <Link to="/websystems/eatsinthewest">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1542912509/rtds_work/Eats%20in%20the%20West/eatsinthemwest-logo-mock.jpg"
                alt="client-app"
              />
            </Link>
          </li>
          <li className="subnav-item">
            <Link to="/websystems/radiantskin">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1555243957/rtds_work/Logo/Radiant_Skin_Logo-19.png"
                alt="client-app"
              />
            </Link>
          </li>
          <li className="subnav-item">
            <Link to="/websystems/racheenaparis">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1542874225/rtds_work/Racheen%20a%20Paris/racheen_a_paris-09.png"
                alt="client-app"
              />
            </Link>
          </li>
          <li className="subnav-item">
            <Link to="/websystems/bayongbags">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1555407775/rtds_work/Logo/BayongBags_USA-12.png"
                alt="client-app"
              />
            </Link>
          </li>
          <li className="subnav-item">
            <Link to="/websystems/washlab">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1555348220/rtds_work/Logo/wash_lab_logo-02.png"
                alt="client-app"
              />
            </Link>
          </li>
          <li className="subnav-item">
            <Link to="/websystems/topwater">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1555348227/rtds_work/Logo/top_water_logo-01.png"
                alt="client-app"
              />
            </Link>
          </li>
          <li className="subnav-item">
            <Link to="/websystems/sweetsandtho">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1555348236/rtds_work/Logo/sat-02.png"
                alt="client-app"
              />
            </Link>
          </li>
          <li className="subnav-item">
            <Link to="/websystems/jeanasdentistry">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1555348248/rtds_work/Logo/jd_logo-01-02.png"
                alt="client-app"
              />
            </Link>
          </li>
          <li className="subnav-item">
            <Link to="/websystems/shoplefranz">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1555406819/rtds_work/Logo/Shop_le_Franz-25.png"
                alt="client-app"
              />
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}

export default SubNav;



// WEBPACK FOOTER //
// ./src/components/pages/category/SubNav.js